var map = {
	"./de_DE/legal/imprint.md": 26311,
	"./de_DE/legal/privacy.md": 44302,
	"./de_DE/legal/terms.md": 67509,
	"./en_US/legal/imprint.md": 96420,
	"./en_US/legal/privacy.md": 70573,
	"./en_US/legal/terms.md": 44990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31822;